import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "../config/axiosInstance";

export const fetchRazorPayStatusForLearntubeX = createAsyncThunk(
    "razorPayLearntubeX/fetch",
    async ({ uuid, payment_id, subscription_id, isError, razorpay_signature, errorObj }) => {
        const response = await axiosNoAuth.post(
            "https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/subscription_payment_status",
            {
                uid: uuid,
                payment_id:payment_id, 
                subscription_id:subscription_id, 
                isError:isError, 
                razorpay_signature:razorpay_signature, 
                errorObj:errorObj
            }
        );
        return response.data;
    },
)

const razorPayLearntubeXSlice = createSlice({
    name: "razorPayLearntubeX",
    initialState: {},
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchRazorPayStatusForLearntubeX.fulfilled, (state, action) => {
            return action.payload;
        });
    },
});

export const selectRazorPayLearntubeXStatus = (state) => state.razorPayLearntubeX;
export default razorPayLearntubeXSlice.reducer;
